import { Action, ActionContext } from 'actions';
import { addProfile } from './addProfile';

export const profileActions = (context: ActionContext) =>
  ({
    add: addProfile(context),
  } satisfies Record<string, Action>);
